import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import TabView from '@/views/tab/TabView.vue'
import ceo from './modules/ceo'
import user from './modules/user'
import mine from './modules/mine'
import community from './modules/community'
import course from './modules/course'
import newsroute from './modules/news'
import exam from '@/router/modules/exam'
import broadcast from './modules/broadcast'
import liveStream from './modules/liveStream'
import task from './modules/task'
import shortVideo from './modules/shortVideo'
import survey from './modules/survey'
import myTraining from './modules/myTraining'
import shop from './modules/shop'
import Home from '@/views/home/Index.vue'
import Course from '@/views/course/Index.vue'
import Community from '@/views/community/Index.vue'
import LiveStream from '@/views/liveStream/index.vue'
import feishuFunc from './modules/feishuFunc'
import My from '@/views/my/Index.vue'
import Unsupported from '@/views/unsupported/index.vue'
import QrcodeSign from '@/views/unsupported/qrcodeSign.vue'
import auditCenter from '@/router/modules/auditCenter'
import MessageCard from '@/views/feishu/messageCard.vue'
import applyCenter from '@/router/modules/applyCenter'
import preview from '@/router/modules/preview'
import i18n from '@/locales'
import { isFeishu, processFeishuJumpData } from '@/utils/feishu'
import { setTitle } from '@/utils/platform'
import { isTudoApp } from '@/utils/tudo'
import { useAuthStore } from '@/stores/login'
import { processWxworkJumpData } from '@/utils/weixinBusiness'
import lecturer from './modules/lecturer'
import faceToTeaching from './modules/faceToTeaching'
import certificate from './modules/certificate'
import { isMobile } from '@/utils/Device'
import { getPcUrl } from '@/utils/urlMapping'
import { mapRouterList } from '@/router/map'
import { buildPcRedirectUrl } from '@/utils/jumpPlatform'
import { isSandsTalkFlutterApp } from '@/utils/sandsTalkFlutter'
import { isSandsTalkMSFlutterApp } from '@/utils/sandsTalkMSFlutter'
import { isSandsTalkNativeApp } from '@/utils/sandsTalkNative'

// 修改标题逻辑：优先级为 isTudoApp -> sandsTalkSiteTitle -> app_sandstalk
const getTitle = () => {
  if (isTudoApp) {
    return 'tudo_sandstalk'
  }
  const sandsTalkSiteTitle = localStorage.getItem('sandsTalkSiteTitle')
  if (sandsTalkSiteTitle) {
    return sandsTalkSiteTitle
  }
  return 'app_sandstalk'
}

const title = getTitle()

let wxworkDataProcessed = false

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: TabView,
    name: 'tab',
    meta: { isOutFieldApp: true, isVnOutfield: true, isMeOutFieldApp: true, isBranchManagerApp: true, isBrMexOutFieldApp: true, isCnDriverApp: true },
    children: [
      {
        path: '/',
        name: 'home',
        component: Home,
        meta: { title, isOutFieldApp: true, isVnOutfield: true, isMeOutFieldApp: true, isBranchManagerApp: true, isBrMexOutFieldApp: true, isCnDriverApp: true }
      },
      {
        path: '/course',
        name: 'course',
        component: Course,
        meta: { title, pageLevel: 2 }
      },
      {
        path: '/community',
        name: 'community',
        component: Community,
        meta: { title }
      },
      {
        path: '/liveStream',
        name: 'liveStream',
        component: LiveStream,
        meta: { title }
      },
      {
        path: '/my',
        name: 'my',
        component: My,
        meta: { title }
      },
      {
        path: '/tabWebview/:id?',
        name: 'tabWebview',
        component: () => import('@/views/tab/TabWebView.vue')
      },
      {
        path: '/tabCommonView/:id?',
        name: 'tabCommonView',
        component: () => import('@/views/tab/TabCommonView.vue')
      },
      {
        path: '/shopIndexTab',
        name: 'shopIndexTab',
        component: () => import('@/views/shop/Index.vue'),
        meta: {
          title: 'shop_mall'
        }
      },
      {
        path: '/lecturerCenterTab',
        name: 'lecturerCenterTab',
        component: () => import('@/views/lecturer/Center.vue'),
        meta: {
          title: 'instructor_center'
        }
      },
      {
        path: '/faceTeachingTab',
        name: 'faceTeachingTab',
        component: () => import('@/views/faceToTeaching/faceTeachingList.vue'),
        meta: {
          title: 'app_offline_teaching'
        }
      },
      {
        path: '/teachManage/TeachManageListTab',
        name: 'TeachManageListTab',
        component: () => import('@/views/my/teachManage/TeachManagementList.vue'),
        meta: {
          title: 'teaching_management'
        }
      },
      {
        path: '/taskTab',
        name: 'taskTab',
        component: () => import('@/views/task/index.vue'),
        meta: {
          title: 'app_task',
          isOutFieldApp: true,
          isMeOutFieldApp: true,
          isBranchManagerApp: true,
          isCnDriverApp: true
        }
      },
      {
        path: '/myStudyTab',
        name: 'myStudyTab',
        component: () => import('@/views/my/MyStudy.vue'),
        meta: {
          title: 'app_my_studies'
        }
      },
      {
        path: '/applyCenterTab',
        name: 'applyCenterTab',
        component: () => import('@/views/applyCenter/Index.vue'),
        meta: {
          title: 'apply_center_h5'
        }
      },
      {
        path: '/myTrainingTab',
        name: 'myTrainingTab',
        component: () => import('@/views/myTraining/index.vue'),
        meta: {
          title: 'app_my_training'
        }
      },
      {
        path: '/examPractiseTab',
        name: 'examPractiseTab',
        component: () => import('@/views/exam/examPractise/index.vue'),
        meta: {
          title: 'app_my_examination'
        }
      },
      {
        path: '/mySurveyTab',
        name: 'mySurveyTab',
        component: () => import('@/views/my/MySurvey.vue'),
        meta: {
          title: 'app_my_survey'
        }
      },
      // 管理员工作台入口
      {
        path: '/workbenchTab',
        name: 'workbenchTab',
        component: () => import('@/views/my/workbench/workbench.vue'),
        meta: {
          title: '管理中心'
        }
      },
      {
        path: '/userSelector',
        name: 'userSelector',
        component: () => import('@/components/UserSelector.vue'),
        meta: {
          title: '人员选择'
        }
      },
      {
        path: '/employeeManagement',
        name: 'EmployeeManagement',
        component: () => import('@/views/my/workbench/employee/EmployeeManagement.vue'),
        meta: {
          title: '员工管理'
        }
      },
      {
        path: '/teamStudyListTab',
        name: 'teamStudyListTab',
        component: () => import('@/views/my/teamStudy/teamStudyList.vue'),
        meta: {
          title: 'pc_my_team'
        }
      },
      {
        path: '/newsTab',
        name: 'newsTab',
        component: () => import('@/views/news/MessageScreen.vue'),
        meta: {
          title: 'app_msg'
        }
      },
      {
        path: '/messageCard',
        name: 'messageCard',
        component: MessageCard,
        meta: { title }
      }
    ]
  },
  // 将 unsupported 和 qrcodeSign 作为独立路由添加到这里
  {
    path: '/employeeManagement',
    name: 'EmployeeManagement',
    component: () => import('@/views/my/workbench/employee/EmployeeManagement.vue'),
    meta: {
      title: '员工管理',
      isKeepAlive: true,
      pageLevel: 2
    }
  },
  {
    path: '/employeeDetail',
    name: 'EmployeeDetail',
    component: () => import('@/views/my/workbench/employee/EmployeeDetail.vue'),
    meta: {
      title: 'user_accountDetail',
      pageLevel: 3
    }
  },
  {
    path: '/unsupported',
    name: 'unsupported',
    component: Unsupported,
    meta: { title, isOutFieldApp: true, isVnOutfield: true, isCnDriverApp: true }
  },
  {
    path: '/qrcodeSign',
    name: 'qrcodeSign',
    component: QrcodeSign,
    meta: { title, isOutFieldApp: true, isVnOutfield: true, isCnDriverApp: true }
  },
  {
    path: '/webview',
    name: 'webview',
    component: () => import('@/views/WebView.vue'),
    meta: { isOutFieldApp: true, thOutfield: true, isMeOutFieldApp: true, isBranchManagerApp: true, isBrMexOutFieldApp: true, isCnDriverApp: true }
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/common/error/Error.vue'),
    meta: { isOutFieldApp: true, thOutfield: true, isMeOutFieldApp: true, isBranchManagerApp: true, isBrMexOutFieldApp: true, isCnDriverApp: true }
  },
  {
    path: '/errorPage',
    name: 'ErrorPage',
    component: () => import('@/views/common/error/ErrorPage.vue')
  },
  ...ceo,
  ...user,
  ...mine,
  ...community,
  ...course,
  ...newsroute,
  ...exam,
  ...broadcast,
  ...liveStream,
  ...task,
  ...shortVideo,
  ...survey,
  ...myTraining,
  ...shop,
  ...auditCenter,
  ...applyCenter,
  ...feishuFunc,
  ...preview,
  ...lecturer,
  ...faceToTeaching,
  ...certificate
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  // PC映射检查 - 在路由进入前执行
  const { wxworkType } = useAuthStore()
  if (!isMobile() && !to.path.startsWith('/error') &&
    wxworkType !== 'wxwork' && !isSandsTalkFlutterApp && !isSandsTalkMSFlutterApp && !isSandsTalkNativeApp) {
    const pcUrl = getPcUrl()
    const routerName = to.name as string
    const mapRoute = mapRouterList.find((item) => item.name === routerName)

    if (routerName && mapRoute) {
      // 直接重定向到PC页面，不渲染H5页面
      window.location.href = buildPcRedirectUrl(to, pcUrl, mapRoute)
      return // 阻止继续执行
    }
  }

  const { setBusinessWechatCode, setBusinessWechatType, setAppId, setJumpName, setJumpType, setJumpModuleId, setCustomTemplateId } =
    useAuthStore()
  setAppId('')
  setJumpName('')
  setJumpType('')
  setJumpModuleId('')
  setCustomTemplateId('')
  const url = window.location.href
  if (!wxworkDataProcessed) {
    if (url && url.indexOf('wxwork') > -1) {
      await processWxworkJumpData(
        url,
        setAppId,
        setBusinessWechatCode,
        setBusinessWechatType,
        setJumpName,
        setJumpType,
        setJumpModuleId,
        setCustomTemplateId
      )
      wxworkDataProcessed = true
    }
  } else if (isFeishu) {
    processFeishuJumpData(url, setAppId, setJumpName)
  }

  if (to.meta.title) {
    if (to.meta.title === 'tudo_sandstalk') {
      setTitle('新锐学堂')
    } else {
      setTitle(i18n.global.t(to.meta.title as string))
    }
  }

  next()
})

router.afterEach((from, to) => {
  if (to?.meta?.customWechatShare) return
  if (window.Wxsdk && typeof window.Wxsdk.wechatShare === 'function') {
    window.Wxsdk.wechatShare({
      title: i18n.global.t('wx_share_title_h5'),
      desc: i18n.global.t('app_click_viewdetails'),
      link: window.location.href,
      imgUrl: `${location.origin}/web/wx_share_default.jpg`
    })
  }
})

export default router
